import { api } from '@/portal-api.definition';
import { useNosIdMutation } from '@/hooks/api/base.hooks';
import { usersQueryOptions } from './get-users.hook';
import { ActionType } from '@nosinovacao/nosid-mfe-common';
import { useQueryClient } from '@tanstack/react-query';

export function useCreateUser() {
  const queryClient = useQueryClient();
  return useNosIdMutation({
    mutationFn: (payload: { DisplayName: string; Email: string; Applications: string[] }) =>
      api.post('/api/v1/users', payload),
    successLogAction: () => ({ ActionType: ActionType.Submit }),
    errorLogAction: () => ({ ActionType: ActionType.Submit }),
    onSuccess: (newUser) => {
      queryClient.setQueryData(usersQueryOptions.queryKey, (prev) => [...(prev ?? []), newUser]);
    },
  });
}
